import React from 'react';
import { Check } from 'lucide-react';

interface StepProps {
  title: string;
  index: number;
  isActive: boolean;
  isCompleted: boolean;
  goToStep: (step: number) => void;
}

const Step: React.FC<StepProps> = ({ index, isActive, isCompleted, goToStep }) => (
  <div
    onClick={() => isCompleted && goToStep(index)}
    className={`w-[32px] h-[32px] border-[1px] text-center items-center flex justify-center border-solid cursor-pointer ${
      isCompleted && isActive
        ? 'bg-[#D5F4E3] border-[1px] border-black'
        : isCompleted
          ? 'border-none bg-[#37AE74] text-[#fff]'
          : isActive
            ? 'border-primary text-primary bg-[#D5F4E3]'
            : 'bg-[#fff] text-[#969696]'
    } rounded-full font-[500]`}
  >
    {isCompleted && !isActive ? (
      <Check size={16} color="#fff" className="flex justify-center text-center" />
    ) : (
      <span className={`font-[500] ${isCompleted ? 'text-primary' : isActive ? 'text-black' : 'text-[#969696]'}`}>
        {index + 1}
      </span>
    )}
  </div>
);

interface StepperProps {
  steps: { title: string; isCompleted: boolean }[];
  activeStep: number;
  goToStep: (step: number) => void;
  mode?: 'edit' | 'create';
}

const Stepper: React.FC<StepperProps> = ({ steps, activeStep, goToStep, mode }) => (
  <div className="flex flex-row items-center">
    {steps.map((step, index) => (
      <div className="flex items-center flex-col" key={index}>
        <div className="flex items-center">
          <Step
            title={step.title}
            index={index}
            isActive={index === activeStep}
            isCompleted={step.isCompleted}
            goToStep={goToStep}
          />

          <div
            className={`h-1 ${
              index < steps.length - 1
                ? index < activeStep || steps[index + 1].isCompleted || mode === 'edit'
                  ? 'bg-[#37AE74]'
                  : 'bg-[#D5F4E3]'
                : 'bg-[#fff]'
            }  `}
            style={{ width: '100px' }}
          ></div>
        </div>
        <span
          className={`ml-[-100px] cursor-pointer h-[40px] flex items-center justify-center w-[120px] text-sm text-center mt-3 ${
            index === activeStep || step.isCompleted ? 'text-black font-[500]' : 'text-[#969696]'
          }`}
          onClick={() => step.isCompleted && goToStep(index)}
        >
          {step.title}
        </span>
      </div>
    ))}
  </div>
);

export default Stepper;
